import { useEffect } from 'react';
import './App.css';
import NavHeader from './components/Header/NavHeader';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import AppRoute from './routes/AppRoute';
import { Watch } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserAccount } from './redux/slice/userSlice';


function App() {
  const dispatch = useDispatch()

  useEffect(() => {
    // Remove credentials/session state left by Scanner_FE versions that used
    // bearer tokens and redux-persist. Authentication now comes from the
    // server-issued HttpOnly cookie.
    localStorage.removeItem('token')
    sessionStorage.removeItem('token')
    localStorage.removeItem('persist:root')
    dispatch(fetchUserAccount())
  }, [dispatch])

  const user = useSelector(state => state.user)

  return (

    <BrowserRouter>
      {user && user.isLoading ?
        <div className='loading-container d-flex justify-content-center'>
          <Watch
            visible={true}
            height="80"
            width="80"
            radius="48"
            color="#000"
            ariaLabel="watch-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
          <div>Loading data...</div>
        </div>
        :
        <>
          <div className='app-header'>
            <NavHeader />
          </div>
          <div className='app-container'>
            <AppRoute />
          </div>
          {/* <Footer /> */}
        </>
      }

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </BrowserRouter>
  );
}

export default App;
